export default {
    opinion: "Comments",
    uploadFile: "Upload file",
    oftenOption: 'Commonly used opinions',
    addDatas: "Add",
    updateDatas: "Update",
    displayOrder: 'Display Order',
    TextPlaceholder: 'Please input your approval comment',
    setOften: 'Set as common',
    opinionHint: 'Set the content you put as common',
    attachment: "Upload File",
    currentNode: 'current node',
    currentHandler: 'current handler',
    selectCurrentHandler: 'Select current handler',
    modifyOwner: "Modify owner",
    ownerDepartment: "Owner department",
    handlingSuggestion: "Handling Suggestion",
    processOperation: 'process operation',
    handlingOpinions: 'handling comments',
    image: "Image",
    total: "Total",
    copy: "Copy",
    delete: "Delete",
    selectNumber: "Select number",
    inputAddress: "Please input address",
    cancel: "Cancel",
    clear: "  Clear",
    ok: "OK",
    reset: "Reset",
    addSign: "Add sign",
    sign: "Sign",
    scanningSignature: "Mobile scanning signature",
    notCloseCode: "Do not close the QR code until the signature is completed",
    scanCodeEquip: "Please scan the code and sign with Wechat, Enterprise Wechat or Dingtalk",
    uploadTips1: "Uploaded files are not limited in format, limited to 50 files, each file within 10MB",
    useLastSign: "Use last signature",
    addition: "Please add",
    addData: 'Add',
    editData: 'Edit',
    expand: "Expand",
    collapse: "Collapse",
    pleaseSelect: "Please select",
    pleaseInput: "Please input",
    scanInput: "Scan code input",
    tenOnly: "10 only",
    province: "Province",
    city: "City",
    countyArea: "County/Area",
    filter: "Filter",
    search: "Search",
    back: "Back",
    number: "NO.",
    indexOf: "NO.{index}",
    searching: "Searching...",
    searchResultTip: "Search result: {total} records",
    searchNoResultTip: 'No search result by "{text}"',
    noMore: "No more",
    noOptions: "No options",
    ChooseNode: 'Choose Activity',
    noData: "No data",
    frozenColumn: "Frozen",
    unFrozenColumn: "Unfrozen",
    checkAll: "Check all",
    clickUpload: "Click here upload",
    dragFiles: "Drag the file here or ",
    action: "Action",
    downloadAll: "Download all",
    templateDownload: "Download attachment template",
    uploadByMobile: "Please take a photo and upload it on your mobile phone",
    singleFileTips: "Each file can't exceed ",
    exportFile: "export",
    importFile: "import",
    startTime: 'Start time',
    endTime: 'End time',
    label: {
        creater: "Creater: ",
        createTime: "Create time: ",
        formStatus: "Status: ",
        sum: "SUM: ",
        avg: "AVG: ",
        min: "MIN: ",
        max: "MAX: "
    },
    formStatus: {
        draft: "DRAFT",
        processing: "PROCESSING",
        completed: "COMPLETED",
        canceled: "CANCELED"
    },
    sheet: {
        clearRow: "Clear up",
        addBefore: "Insert the line up",
        addAfter: "Insert the line down",
        logicFalseValue: "false",
        logicTrueValue: "true"
    },
    tip: {
        clickPosition: "Click position",
        onlySupportMobileWrite: "only support mobile write",
        onlySupportPcWrite: 'Only support enter by PC',
        clickAndDropUpload: "Click and drop upload",
        position: "PC may have positioning deviation , use mobile for precise positioning.",
        frozenColumnMax: "Up to 3 columns frozen, please cancel the frozen column first",
        frozenColumnWidthMax: "The total width of the frozen column has exceeded the width of the form. Please reset the column width",
        previewError: "The file type is not supported. Please check it on PC",
        importError: "Incorrect template, please check",
        uploadError: 'Failed to upload, please try again',
        uploadTotal: "uploaded {total} files",
        overSize: "The uploaded file can't  be greater than {label} MB",
        fileNameCheck: "The file name can't contain special characters ','",
        imageNameCHeck: "The picture name can't contain special characters ','",
        imageSuport: `Wrong picture format，only supported format is {label}`,
        fileSuport: 'Wrong file format,only supported format is {label}',
        fileUnsuport: "Wrong file format，can't supported format is {lable}",
        requiredError: 'Please complete the required content',
    },
    errorCode: {
        min: "{label} can't be less than the minimum",
        max: "{label} can't be greater than the maximum",
        minCount: "The number of {label} cannot be greater than {num}",
        maxCount: "The number of {label} cannot be less than {num}",
        input: "Please input {label}",
        select: "Please select {label}",
        inputErr: 'Please enter the correct content',
        selectErr: 'Please select the correct content',
    },
    MyDept: 'My Department',
    DingTalk: 'DingTalk',
    WeChat: 'Qiwei',
    SelfMain: 'Self Maintenance',
    Loading: 'Loading...',
    NoData: 'No data',
    HasSelected: 'Selected: {num}',
    SelectRole: 'Select Role',
    SearchRole: 'Search Role',
};
